'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { trackClickEvent } from '@/utils/site-track';
import LogoImage from '@/assets/common/logo.png';

const Logo = (props: { href: string; className?: string }) => {
  const { href, className } = props;
  return (
    <Link
      href={href}
      className={className}
      onClick={(e) => {
        trackClickEvent(e, true);
      }}
      data-ele-group="navigation"
      data-ele-id="btn_logo"
    >
      <Image alt="logo" src={LogoImage} width={49} height={24} />
    </Link>
  );
};

export default Logo;
